module.exports = __webpack_public_path__ + "img/pref_cover.77a14dfa.png";